module.exports = __webpack_public_path__ + "assets/img/ic-save.32da9b3a.svg";